import React from "react";
import classNames from "classnames";
import s from "./MentorCardSeparator.pcss";

const MentorCardSeparator = (props) => <div className={classNames(s.separator, props.className)} />;

MentorCardSeparator.propTypes = {};

export default MentorCardSeparator;
